import { render, staticRenderFns } from "./StockInventorySidebar.vue?vue&type=template&id=0291b676&scoped=true&"
import script from "./StockInventorySidebar.vue?vue&type=script&lang=js&"
export * from "./StockInventorySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0291b676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0291b676')) {
      api.createRecord('0291b676', component.options)
    } else {
      api.reload('0291b676', component.options)
    }
    module.hot.accept("./StockInventorySidebar.vue?vue&type=template&id=0291b676&scoped=true&", function () {
      api.rerender('0291b676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/stock/stock-inventory/components/StockInventorySidebar.vue"
export default component.exports